export enum PriceBookStatus {
  Active = "ACTIVE",
  Draft = "DRAFT",
  Archived = "ARCHIVED",
}
